import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { provide } from 'vue'
import { ToastQueueStoreKey } from './BsToastQueueStore.interfaces'
import { createToastQueueStore } from './BsToastQueueStore.composition'


export default /*#__PURE__*/_defineComponent({
  __name: 'BsToastQueueStore',
  setup(__props) {

const toastQueueStore = createToastQueueStore()
provide(ToastQueueStoreKey, toastQueueStore)

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { store: _unref(toastQueueStore) })
}
}

})